import { Injectable } from '@angular/core';
import { SlWapiService } from './sl-wapi.service';
import { Decorable } from 'src/app/types/decorable';
import { MapService } from 'src/app/services/map.service';
import { CancellablePromise, ICancellablePromise } from 'src/app/types/cancellable-promise';
import { SLLayer } from '../sl-layer';
// @ts-ignore
import { LngLat, Point } from '!mapbox-gl';
import { SLMap } from '../sl-map';
import { BBOXArray } from 'src/app/types/@types/sl-v-types';
import { BufferSrc } from '../buffersrc';


export type FitSet = {
  feature_layer: string | number;
  feature_field: string | number;
  features: Array<string | number>;
  un_features?: Array<string | number>;
}


export interface QueryPromise {
  promise: CancellablePromise,
  params: any
}

@Injectable({
  providedIn: 'root'
})
export class LayersApiService {


  private layers: Array<SLLayer>;

  constructor(private wapi: SlWapiService, mapService: MapService) {
    mapService = mapService;
    this.layers = [];
  }
  Push(layer: SLLayer) {
    this.layers.push(layer);
  }
  QueryLayersByBbox(
    map: SLMap,
    bbox: BBOXArray,
    layers: Array<SLLayer>,
    featureLimit: number = Infinity,
    bufferDistance?: number,
    geomAs: string = 'false',
    visOnly: boolean = false): QueryPromise {

    const params: Decorable = {};

    if (layers !== undefined) {
      if (layers.length !== 0) {

        const isProjectLayer = layers[0].isPLayer;
        const layerIds: Array<string> = [];
        for (const layer of layers) {
          if (visOnly === true) {
            if (layer.layerOn === false) {
              continue;
            }
          }
          layerIds.push(layer.identifier);
        }
        params.geom = geomAs;
        if (isProjectLayer) {
          params.players = layerIds.join(',');
          params.project = map.project.id;
        } else {
          params.layers = layerIds.join(',');
        }
        if (featureLimit !== Infinity) {
          params.limit = featureLimit;
        }
        if ([null, undefined, 0].indexOf(bufferDistance) === -1) {
          params.distance = bufferDistance;
        }
        params.bbox = bbox.join(',');
        params.inputType = 'rect';


      }
    }
    return { promise: this.wapi.Post('features/query', params, true), params: (params) };
  }
  QueryLayers(
    map: SLMap,
    mapPoint: LngLat = null,
    layers: Array<SLLayer> = null,
    featureLimit: number = 1,
    bufferSrc?: BufferSrc,
    geomAs: string = 'false',
    featureLayer: number | string = null,
    gids: Array<any> = null,
    exact: boolean = false,
    visOnly: boolean = false,
    pxBuffer?: number): QueryPromise {
    let isProjectLayer = false;
    if (!pxBuffer) {
      const extras = map.environmentService.GetExtraParams();
      if (!!extras?.tooltip_radius) {
        pxBuffer = Number(extras.tooltip_radius);
        if (pxBuffer % 2 === 0) pxBuffer += .5;
      } else {
        pxBuffer = 12.5;
      }
    }

    if (layers === null) {
      layers = [];
      for (const layer of map.layers) {
        isProjectLayer = layer.isPLayer;
        if (layer.searchable || !isProjectLayer) {
          if (visOnly === true) {
            if (layer.layerOn === false) {
              continue;
            }
          }
          layers.push(layer);
        }
      }
    } else {
      isProjectLayer = layers[0].isPLayer;
    }

    const layerIds: Array<string> = [];
    for (const layer of layers) {
      if (layer.searchable || !isProjectLayer) {
        if (visOnly === true) {
          if (layer.layerOn === false) {
            continue;
          }
        }
      }
      layerIds.push(layer.identifier);
    }

    const params: Decorable = {
      geom: geomAs

    };

    if (isProjectLayer) {
      params.players = layerIds.join(',');
      params.project = map.project.id;
    } else {
      params.layers = layerIds.join(',');
    }
    if (featureLimit !== Infinity) {
      params.limit = featureLimit;
    }
    let hasBuffer = false;
    if (!!bufferSrc) {
      if (bufferSrc.value !== 0) {
        hasBuffer = true;
      }
    }
    featureLayer = isNaN(Number(featureLayer)) ? ((featureLayer as string).substring(0, 1) === '{' ? featureLayer : '') : Number(featureLayer);
    this.DecorateQByFeature(params, featureLayer, gids, bufferSrc);

    if (hasBuffer === true) {
      this.DecorateQByDistance(params, bufferSrc, mapPoint);
    } else {
      if (mapPoint === null) {
        return;
      }
      this.DecorateQByPoint(params, mapPoint, map, pxBuffer);
    }
    params.exact = exact;

    return { promise: this.wapi.Post('features/query', params, true), params: (params) };
  }

  DecorateQByFeature(params: any, featureLayer: number | string, gids: Array<any>, bufferSrc?: BufferSrc, exact: boolean = false) {
    if (featureLayer === '') return;
    if ((('' + featureLayer).substring(0, 1) === '{') && (featureLayer !== '{}')) {
      params.featureLayer = featureLayer;
    } else if (Number(featureLayer) < 0) {
      params.filterLayer = Number(featureLayer) * -1;
    } else {
      if (featureLayer !== '{}') {
        params.memoryLayer = featureLayer;
      }
    }
    params.gids = (gids ?? []).join(',');
    // BufferSrc.Convert(bufferSrc);
    const bufferDistance = (!!bufferSrc) ? bufferSrc.value : null;
    if (!exact && (bufferDistance !== null)) {
      params.distance = bufferDistance;
    }
  }
  DecorateQByDistance(params: any, bufferSrc: BufferSrc, point: LngLat) {
    if (bufferSrc.value !== 0) {
      params.distance = bufferSrc.value;
      params.centerLon = point.lng;
      params.centerLat = point.lat;
      params.inputType = 'point';
    }
  }
  DecorateQByPoint(params: any, point: LngLat, map: SLMap, pxBuffer: number = 14.5) {
    const centerPoint: Point = map.ui.project(point);
    params.centerLon = point.lng;
    params.centerLat = point.lat;
    const nePoint: Point = centerPoint.clone();
    nePoint.x += pxBuffer;
    nePoint.y += pxBuffer;
    const swPoint = centerPoint.clone();
    swPoint.x -= pxBuffer;
    swPoint.y -= pxBuffer;
    const swCoord: LngLat = map.ui.unproject(swPoint);
    const neCoord: LngLat = map.ui.unproject(nePoint);

    const bbox: Array<number> = [
      Math.min(swCoord.lng, neCoord.lng),
      Math.min(swCoord.lat, neCoord.lat),
      Math.max(swCoord.lng, neCoord.lng),
      Math.max(swCoord.lat, neCoord.lat)
    ];
    params.bbox = bbox.join(',');
    params.inputType = 'point';

  }
  GetLayerById(layerId): SLLayer | null {
    for (const layer of this.layers) {
      if (layer.id === layerId) {
        return layer;
      }
      return null;
    }
  }
  GetLayerByPlid(plid): SLLayer | null {
    for (const layer of this.layers) {
      if (!layer.plid) continue;
      if (layer.plid === plid) return layer;
    }
    return null;
  }
  GetSrcLayers(viewName = 'mine'): CancellablePromise {
    return this.wapi.Post('layers/views/get/view:' + viewName + '/', {}, true);
  }
  AddLayerToProject(mapId, layerId): ICancellablePromise {
    return this.wapi.Post('layers/layer/add_to_map', { mid: mapId, lid: layerId });
  }
  RemoveLayerFromProject(mapId, pLayerId): ICancellablePromise {
    return this.wapi.Post('layers/layer/remove_from_map', { mid: mapId, plid: pLayerId });
  }
  GetFitExtents(sets: Array<FitSet>, buffer: number = 0): ICancellablePromise {
    const payload: any = { 'sets': JSON.stringify(sets) };
    if (buffer !== 0) payload.buffer = buffer;
    return this.wapi.Post('map/navigate/fit', payload);
  }
}
